import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Announcement,
  Button,
  Input,
  isMaxNameLength,
  ModalV2 as Modal,
  NewFolderIcon,
} from '@utilities';

import styles from './_index.module.scss';

const CreateFolder = ({ createFolder, onSubmit }) => {
  const [error, setError] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState('');

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      await createFolder({ name });
      onSubmit();
      setIsActive(false);
    } catch (error) {
      setError(error?.response?.data);
      console.error(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setName('');
    setError([]);
    setIsLoading(false);
  }, [isActive]);

  return (
    <>
      <Button
        data-testid="create-folder-button"
        onClick={() => setIsActive(true)}
        text={
          <>
            <NewFolderIcon /> Create Folder
          </>
        }
        variant="secondary"
      />
      <Modal
        buttons={[
          <Button
            key="cancel-btn"
            onClick={() => setIsActive(false)}
            text="Cancel"
            variant="secondary"
          />,
          <Button
            isDisabled={name.trim().length === 0 || isMaxNameLength(name)}
            isLoading={isLoading}
            key="submit-btn"
            onClick={handleSubmit}
            text="Save"
          />,
        ]}
        className={styles['create-folder']}
        isActive={isActive}
        onClose={() => setIsActive(false)}
        title="Create Folder"
      >
        {error && error?.length > 0 && <Announcement text={error} variant="error" />}
        <Input
          error={
            isMaxNameLength(name)
              ? 'Maximum number of characters reached. Try something shorter.'
              : ''
          }
          label="Folder Name"
          onChange={setName}
          placeholder="Enter name"
          value={name}
        />
      </Modal>
    </>
  );
};

CreateFolder.propTypes = {
  createFolder: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default CreateFolder;
